<div>
    <img
        [src]="'assets/images/partner-salons/' + partnersUnique.logo"
        [alt]="partnersUnique.name"
        [style.backgroundColor]="partnersUnique.bgColor ?? 'transparent'"
        [style.padding.rem]="partnersUnique.bgColor ? '2' : '2'"
    />
    <h6 class="text-gray-300 fs-15 fw-700 text-center font-secondary mb-1">{{ partnersUnique.name }}</h6>
</div>
